import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';

import { CardMessageCartaIsencaoIpiVencidaComponent } from './card-message-carta-isencao-ipi-vencida.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CardMessageCartaIsencaoIpiVencidaComponent
    ],
    exports: [
        CardMessageCartaIsencaoIpiVencidaComponent
    ]
})
export class CardMessageCartaIsencaoIpiVencidaModule { }
